<template>
  <div class="RwvContentToggle">
    <b-button
      block
      v-b-toggle="'collapse-' + index"
      :variant="content.variant"
      title="Inhalt aus-/einklappen"
      v-b-tooltip.hover>
        {{content.title}}
      </b-button>
    <b-collapse :id="'collapse-' + index" class="mt-2">
      <b-card>
        <RwvContent :index="index" :content="content.content" :isWithToggle="false"/>
      </b-card>
    </b-collapse>
  </div>
</template>

<script>

export default {
  name: "RwvContentToggle",
  props: {
    content: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  beforeCreate: function () {
    this.$options.components.RwvContent = require('../Content.vue').default
  }
};
</script>

<style lang="scss">
.RwvContentToggle {
  margin: 1em auto;
}
</style>
